<template>
  <div class="card mt-2">
    <div class="border-0 card-header">
      <div class="row">
        <div class="col-md-6 px-2">
          <label class="form-control-label">Período Comercial</label>
          <multiselect
            v-model="filter.commercial"
            filterable
            :options="commercials"
            placeholder="Selecione um período Comercial"
            label="name"
            track-by="id"
          />
        </div>
        <div class="col-md-6 px-2">
          <label class="form-control-label">Marca</label>
          <multiselect
            v-model="filter.name"
            filterable
            :options="commercialBrands"
            placeholder="Selecione uma Marca"
            label="name"
            track-by="name"
            :internal-search="false"
            @search-change="debouncedGetCommmercialBrands"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { Select, Option, Loading } from "element-ui";
export default {
  name: "filter-commercial",
  props: ['val', 'value', 'brand'],
  components: {
    Multiselect,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      filter: {
        commercial: {}
      },
      product: null,
      commercialBrands: [],
      commercials: [],
      getCommmercialBrandTimeout: null,
    };
  },
  async mounted() {
    this.getComercials();    
  },
  methods: {
    debouncedGetCommmercialBrands(name) {
      if (this.getCommmercialBrandTimeout) clearTimeout(this.getCommmercialBrandTimeout);

      this.getCommmercialBrandTimeout = setTimeout(() => {
        this.getCommmercialBrands(name);
      }, 500);
    },
    async getCommmercialBrands(name) {
      const q = { commercial_id: this.filter.commercial.id }
      if (name) q.name = name

      const response = await this.$http.secured.get("/api/v2/commercial_brands", {
        params: {
          q: q
        },
      })

      this.commercialBrands = response.data.data || [];
    },
    async getComercials() {
      const response = await this.$http.secured.get("/api/v2/commercials.json")

      this.commercials = response.data || [];
      this.filter.commercial = this.commercials.filter((commercial) => commercial.is_open == true)[0] || {}
      this.commercial = this.filter.commercial
    },
  },
  watch: {
    "filter.commercial": {
      handler(val) {
        if (val) this.getCommmercialBrands();

        this.$emit("selected-commercial", val || {});
        
      },
    },
    "filter.name": {
      handler(brand) {
        this.$emit("selected-brand", brand && brand.id || null);
      },
    },
  },
  computed: {
    commercial: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
};
</script>
